import type {
    SxProps,
    Theme
} from '@mui/material/styles';

const styles = {
    button: (theme) => ({
        '& span': {
            textTransform: 'none'
        },

        '&.MuiButton-sizeSmall': {
            borderWidth: '1px',
            px: 3,
            py: 1
        },

        '&:focus-visible': {
            boxShadow: `0 0 0 2px ${theme.colors.white}`,
            outline: `2px solid ${theme.colors.teal}`,
            outlineOffset: 2
        },

        '@media (forced-colors: active)': {
            '&:focus-visible': {
                boxShadow: 'none',
                outlineColor: 'Highlight'
            }
        },

        borderRadius: 12,
        borderWidth: '2px',
        px: 5,
        py: 2,
        textTransform: 'none',
        transition: 'color .2s ease-out, background-color .2s ease-in, transform .2s ease'
    }),

    contained: {
        '&:not(.Mui-disabled):hover, &:not(.Mui-disabled):focus-visible': {
            textDecoration: 'none !important',
            transform: 'scale(1.03)'
        }
    },

    fullWidth: {
        width: {
            md: 'auto',
            xs: '100%'
        }
    },

    outlined: {
        '&:not(.Mui-disabled):hover': {
            textDecoration: 'none !important',
            transform: 'scale(1.03)'
        }
    },

    text: {
        '&:not(.Mui-disabled):hover': {
            textDecoration: 'underline'
        },

        backgroundColor: 'transparent !important',
        padding: '0 !important',
        textDecoration: 'underline',
        whiteSpace: 'pre-line'
    }
} satisfies Record<string, SxProps<Theme>>;

export default styles;
